module.exports = "/assets/data/73326cea51501b2d3151b37e8d7d72ac-EX8.data.json";